// Steps

const steps = () => {

    window.Parsley.addValidator('fileextension', {
        requirementType: 'string',
        validateString: function (value, requirement) {
            var fileExtension = value.split('.').pop();

            return fileExtension === requirement;
        },
        messages: {
            'en': 'Invalid file type'
        }
    })

    let currentStep = 1;
    const nextButton = document.querySelectorAll('#js-next-step');

    const formSection = document.querySelectorAll('.investment-form-title');

    var $form = $('#investment-form');

    if ($form.is('.investment-form-success'))
    {
        return;
    }

    $form.find('.form-step').each(function (idx, el) {
        $(el).find('input, textarea, select').not('input[type=button], input[type=submit], input[type=reset], input[type=hidden]').attr('data-parsley-group', 'step-' + (idx+1));
    });

    let inputAttributes = {
        textarea: {
            parent: '.text-area',
            error: 'text-area--error',
            success: 'text-area--success'
        },
        text: {
            parent: '.input-field',
            error: 'input-field--error',
            success: 'input-field--success'
        },
        email: {
            parent: '.input-field',
            error: 'input-field--error',
            success: 'input-field--success'
        },
        'select-one': {
            parent: '.select',
            error: 'select--error',
            success: 'select--success'
        },
        tel: {
            parent: '.input-field',
            error: 'input-field--error',
            success: 'input-field--success'
        }
    }

    function getInputAttributes(el)
    {
        let $el = $(el);
        let type = $el.prop('type').toLowerCase();

        return inputAttributes[type];
    }

    for (var i = 0; i < nextButton.length; i++) {
        let idx = i + 1;
        nextButton[i].onclick = (e) => {
            e.preventDefault();

            let promise = validateStep('#investment-form', idx).then(function () {
                let stepIdx = idx+1;
                goToStep(stepIdx);

                setTimeout(function () {
                    let step = document.getElementsByClassName(`form-step-${stepIdx}`);

                    for (let item of step)
                    {
                        item.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                        break;
                    }
                }, 50);

            });
        }
    }

    // this should only be able to do if you have completed the previous step

    for(let i = 0 ; i < formSection.length ; ++i){
        formSection[i].addEventListener('click', ()=>{
            if (i < currentStep)
            {
                goToStep(i+1);
            }
        })
     }

     function getFirstName(){
        let inputFirstNameVal = document.getElementById("first_name").value;
        let greetingTextElement = document.getElementById('investment-form-greeting-name');
        let greetingText = `<b> 5. Nice to meet you, ${inputFirstNameVal} - What is your company’s name? </b>`;
        greetingTextElement.innerHTML = greetingText;
      }

    function validateStep($form, step) {
        return new Promise(function (resolve, reject) {
            $($form).parsley({
                errorsContainer: function (field) {
                    var $formField = field.$element.parents('.form-field')
                    var $el = $formField.find('.form-field__content');
                    if ( ! $el.length )
                    {
                        $el = $('<div>').addClass('form-field__content');
                        $formField.append($el);
                    }
                    return $el;
                },
                classHandler: function (field) {
                    let attrs = getInputAttributes(field.$element);
                    let parent = attrs && attrs.hasOwnProperty('parent') ? field.$element.parents(attrs.parent) : field.$element;
                    parent.data('input-attrs', attrs);
                    return parent;
                },
                errorClass: function () {
                    let attrs = $(this).data('input-attrs');
                    return attrs && attrs.error ? attrs.error : null;
                },
                successClass: function () {
                    let attrs = $(this).data('input-attrs');
                    return attrs && attrs.success ? attrs.success : null;
                },
                errorTemplate: '<span class="form-field__message"></span>',
                errorsWrapper: '<span class="form-field__message-wrapper" aria-hidden="false" type="error"></span>'

            }).on('field:validate', function (field) {
                let $parent = field.$element.parents('.form-field');
                $parent.removeClass('form-field--valid').removeClass('form-field--error');
                $parent.find('.form-field__icon-wrapper').remove();
                field.$element.parents('.select').removeClass('select--error')
            }).on('field:validated', function (field) {
                if (field.constraints.length)
                {
                    let $parent = field.$element.parents('.form-field');
                    let className = field.isValid() ? 'form-field--valid' : 'form-field--error';
                    $parent.addClass(className);
                    if ( ! $parent.find('.form-field__icon-wrapper').length) {
                        $('<span class="form-field__icon-wrapper"><svg focusable="false" viewBox="0 0 24 24" class="svg-icon form-field__icon" aria-hidden="true"><path d="M12.9482 13.1025h-2.0035v-6h2l.0035 6zm-2.25 2.75c0-.6903.5597-1.25 1.25-1.25.6904 0 1.25.5597 1.25 1.25 0 .6904-.5596 1.25-1.25 1.25-.6903 0-1.25-.5596-1.25-1.25z"></path></svg></span>').insertBefore($parent.find('[type=error] .form-field__message'))
                    }
                }


            }).whenValidate({
                group: 'step-' + step
            }).done(resolve).catch(reject);
        })
    }


    let goToStep = (stepNumber) => {
        currentStep = stepNumber;
        let stepClass = `form-step-${currentStep}`;
        let allSteps = document.getElementsByClassName('form-step');
        let step = document.getElementsByClassName(stepClass);

        getFirstName();

        //except for current step
        for (let i = 0; i < step.length; ++i) {
            show(step[i]);
        }

        //hide all steps
        for (let i = 0; i < allSteps.length; ++i) {
            if (! allSteps[i].classList.contains(stepClass))
            {
                hide(allSteps[i]);
            }

        }
    }

    function validateSteps($form) {
        return new Promise(function (resolve, reject) {
            let allSteps = document.getElementsByClassName('form-step');

            let doValidate = function (step) {
                validateStep($form, step).then(function () {
                    let next = step + 1;
                    if (next <= allSteps.length)
                    {
                        doValidate(next);
                    }
                    else
                    {
                        resolve();
                    }
                }).catch(function () {
                    reject(step);
                })
            }

            doValidate(1);
        })

    }

    window.gotoStep = goToStep;
    window.validateStep = validateStep;
    window.validateSteps = validateSteps;


    let show = (element) => {
        element.classList.add('active');
    }

    let hide = (element) => {
        element.classList.remove('active');
    }

}

document.addEventListener("DOMContentLoaded", function() {
    steps();

    let fileDragDrop = document.querySelectorAll('.file-drop input[type=file]');

    // let fileInput =  document.getElementById('investment-form-file');

    // console.log(fileInput.files[0].name);

    const bodyDragStart = new Event('bodydragstart');
    const bodyDragStop = new Event('bodydragstop');

    fileDragDrop.forEach(item => {
        let container = item.closest('.file-drop');

        item.onchange = function () {
            if (this.value)
            {
                container.classList.add('has-value');
                let fileName = this.files[0].name;
                let fileNameText = document.querySelector('.filename');
                fileNameText.textContent = fileName;
            }
            else
            {
                container.classList.remove('has-value');
            }
        }

        item.ondragenter = function () {
            container.classList.add('drag-over');
        }

        item.ondragleave = function () {
            container.classList.remove('drag-over');
        }

        item.addEventListener('bodydragstart', function () {
            container.classList.add('dragging');
        })

        item.addEventListener('bodydragstop', function () {
            container.classList.remove('dragging');
            container.classList.remove('drag-over');
        })
    });

    let body = document.body;

    function testElementEvent(el, tag)
    {
        return !el || el.tagName.toLowerCase() == tag;
    }



    body.addEventListener('dragenter', function (e) {
        if (testElementEvent(e.fromElement, 'html'))
        {
            fileDragDrop.forEach(item => {
                item.dispatchEvent(bodyDragStart);
            })
        }
    });

    body.addEventListener('dragleave', function (e) {
        if (testElementEvent(e.fromElement, 'html'))
        {
            fileDragDrop.forEach(item => {
                item.dispatchEvent(bodyDragStop);
            })
        }
    });

    body.addEventListener('drop', function () {
        fileDragDrop.forEach(item => {
            item.dispatchEvent(bodyDragStop);
        });
    });
});
